module.exports = __webpack_public_path__ + "static/media/buggy.d19536ba.png";